import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const BookingCta = ({ title = "Pronto para dar o primeiro passo?", subtitle = "Consultas desde 45€ · confirmação imediata por email · pagamento no local." }) => (
  <div className="max-w-7xl mx-auto px-6 lg:px-10" data-testid="booking-cta-strip">
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 border-y border-rose-100 py-8">
      <div>
        <p className="font-display text-2xl text-stone-900">{title}</p>
        <p className="text-sm text-stone-500 mt-1">{subtitle}</p>
      </div>
      <Link
        to="/marcacao"
        data-testid="booking-cta-strip-btn"
        className="btn-rose group inline-flex items-center justify-center gap-2 rounded-full bg-rose-800 text-white px-7 py-3.5 text-sm shrink-0"
      >
        Marcar consulta
        <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </Link>
    </div>
  </div>
);
